import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import FogOverlay from "../components/FogOverlay";
import WindDust from "../components/WindDust";
import PageMeta from "../components/PageMeta";
import RichText from "../i18n/RichText";
import { useForcedLanguage, useLanguage } from "../i18n/LanguageContext";

const NotFound = () => {
  // The 404 page is always in English, whatever language the visitor picked.
  useForcedLanguage("en");
  const { preferredLanguage, t } = useLanguage();

  return (
    <>
      <PageMeta noindex selfCanonical={false} />
      <div className="relative w-full h-dvh overflow-hidden bg-black flex items-center justify-center bg-home before:absolute before:inset-0 before:content-[''] z-0 before:bg-black/50">
        <Navbar />
        <FogOverlay />

        <motion.div
          style={{ zIndex: 30 }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="flex flex-col items-center gap-y-3 px-10 text-center"
        >
          <div
            aria-hidden="true"
            className="barrio-regular text-[#FF6355] leading-none text-[90px] 2xl:text-[140px]"
          >
            {t("notFound.code")}
          </div>
          <h1 className="barrio-regular text-[#FFEDD6] leading-none text-[30px] 2xl:text-[50px]">
            <RichText
              text={t("notFound.title")}
              highlightClass="text-[#FF6355]"
            />
          </h1>
          <p className="didot-bold text-[#FFEDD6] text-sm 2xl:text-xl max-w-md">
            {t("notFound.description")}
          </p>
          <Link
            to={`/${preferredLanguage}`}
            className="transition-all duration-300 hover:text-[#FF6355] hover:bg-[#FFEDD6] mt-3 tracking-widest barrio-regular rounded-xl text-[#FFEDD6] bg-[#FF6355] py-2 px-5 text-xl 2xl:text-2xl"
          >
            {t("notFound.button")}
          </Link>
        </motion.div>

        <WindDust />
      </div>

      <Footer />
    </>
  );
};

export default NotFound;
